export const rejectAfterTimeout = <T>(taskPromise: Promise<T>, timeoutError: Error, timeoutMS: number): Promise<T> => {
  const timeoutPromise = new Promise<T>((_, reject) => {
    setTimeout(() => reject(timeoutError), timeoutMS);
  });
  return Promise.race<T>([taskPromise, timeoutPromise]);
};

export const defer = async <T>(task: () => T | PromiseLike<T>, deferMS: number): Promise<T> => {
  const deferPromise = new Promise<number>((resolve) => {
    const timeout = setTimeout(() => resolve(timeout), deferMS);
  });
  clearTimeout(await deferPromise);
  return task();
};
